import { render, staticRenderFns } from "./healthSafety.vue?vue&type=template&id=c44e7bd6&scoped=true&"
import script from "./healthSafety.vue?vue&type=script&lang=js&"
export * from "./healthSafety.vue?vue&type=script&lang=js&"
import style0 from "./healthSafety.vue?vue&type=style&index=0&id=c44e7bd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44e7bd6",
  null
  
)

export default component.exports